import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Divider, Paragraph1, RadioButton } from 'inpock-ui-react';
import styled from '@emotion/styled';

import { DetailedOrderLine } from '@/apis';
import { BottomFixedSheet, Box } from '@/components/common';
import { generateOrderlineName } from '@/utils';
import { REVIEW_SESSION_KEY } from '@/constants';

import { OrderItem } from '../OrderItem';

interface ReviewSheetProps {
  visible: boolean;
  orderGroupNumber: string;
  onDismiss: () => void;
  orderlines?: DetailedOrderLine[];
}

export function ReviewSheet({
  visible,
  orderGroupNumber,
  onDismiss,
  orderlines,
}: ReviewSheetProps) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(visible);
  const [selectedOrderline, setSelectedOrderline] = useState<DetailedOrderLine | null>(null);

  const onClickWriteReview = () => {
    if (!selectedOrderline) return;
    sessionStorage.setItem(
      REVIEW_SESSION_KEY,
      JSON.stringify({
        orderline: selectedOrderline,
        order_group_number: orderGroupNumber,
      }),
    );

    return navigate(`/customer/orders/review/${selectedOrderline.orderline_number}/register`);
  };

  return (
    <BottomFixedSheet
      open={open}
      onDismiss={() => {
        setOpen(false);
        onDismiss();
      }}
      footer={
        <div className="d-flex" style={{ gap: '12px' }}>
          <Button
            type="default"
            size="medium"
            fullWidth
            style={{ flex: 3 }}
            onClick={() => {
              setOpen(false);
              onDismiss();
            }}
          >
            다음에
          </Button>
          <Button
            type="primary"
            size="medium"
            fullWidth
            style={{ flex: 7 }}
            disabled={!selectedOrderline}
            onClick={onClickWriteReview}
          >
            리뷰작성
          </Button>
        </div>
      }
    >
      <div style={{ padding: '0 12px' }}>
        <Box
          flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          sx={{ gap: '7px' }}
        >
          <Paragraph1>리뷰 작성 완료 🙌🏻</Paragraph1>
          <Paragraph1>다른 상품의 리뷰도 작성해 보세요!</Paragraph1>
        </Box>
        <Divider spacing={20} />
        {orderlines?.map((orderline) => (
          <div
            className="d-flex mt-20"
            key={orderline.orderline_number}
            onClick={() => setSelectedOrderline(orderline)}
          >
            <StyledRadioButton
              value={orderline.orderline_number === selectedOrderline?.orderline_number}
            />
            <OrderItem
              image={orderline.campaign_image[0].image}
              campaignName={orderline.campaign_name}
              orderlineName={generateOrderlineName(
                orderline.additional_product_name,
                orderline.additional_option_name,
                orderline.main_option_name,
                orderline.sub_option_name,
                orderline.quantity,
              )}
              clickable
            />
          </div>
        ))}
      </div>
    </BottomFixedSheet>
  );
}

const StyledRadioButton = styled(RadioButton)`
  align-self: flex-start;
`;
